import axios from './axios'
import qs from 'qs'
import { CONTENT_TYPE } from './constant'

export const generateOnSessionSignature = (params = {}) =>
  axios.post('/opc/onsession/signature/generate', qs.stringify(params), {
    headers: {
      'Content-Type': CONTENT_TYPE.URL_ENCODED
    }
  })

export const generateCvvReAuthSignature = () => axios.get(`/billing/zuora/signature/generate_cc_reauth?_=${Date.now()}`)

export const generateZuoraSignature = () => axios.get(`/billing/zuora/signature/generate?_=${Date.now()}`)

export const generateZuoraAchSignature = () => axios.get(`/billing/zuora/signature/generate_ach?_=${Date.now()}`)

export const generateZuoraSepaSignature = () => axios.get(`/billing/zuora/signature/generate_sepa?_=${Date.now()}`)

export const updateCvvFlag = (params) =>
  axios.post('/billing/fraud/cvv', qs.stringify(params), {
    headers: {
      'Content-Type': CONTENT_TYPE.URL_ENCODED
    }
  })

export const updatePayMethod = (params) => axios.post('/payment/update', params)

export const checkRpsStatus = (params) =>
  axios.post('/buy/e2open_check', qs.stringify(params), {
    headers: {
      'Content-Type': CONTENT_TYPE.URL_ENCODED
    }
  })
export const getCountryJson = (lang = '') => axios.get(`/buy/getCountryJson?lang=${lang}`)

export const getPaymentBillingInfo = () => axios.get('/payment/info', { params: { pageType: '' } })

export const getPaymentGatewayInfo = () => axios.get('/payment/gateway/info')

export const paypalPlan = (params) =>
  axios.post('/paypal_plan', qs.stringify(params), {
    headers: {
      'Content-Type': CONTENT_TYPE.URL_ENCODED
    }
  })

export const getApmPaymentMethods = ({ soldToCountry, billToCountry, currencyCode, email, planNames }) =>
  axios.post(
    '/apm/payment-methods',
    {},
    {
      params: {
        soldToCountry,
        billToCountry,
        currencyCode,
        email,
        planNames,
        showDefaultTiles: 'true'
      },
      timeout: 15000,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  )

// set apm info to be sent to APM pages
export const apmSetInfo = ({ payload }) => axios.post('/apm/set/info', payload)

// APM update payment setup for billing management flow
export const updatePaymentSetup = ({ payload, email }) =>
  axios.post(`/apm/payment-method/update?email=${encodeURIComponent(email)}`, payload)
